/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, name: NonNullable<unknown> }} Tea_Purchase_Paid_At_ByInputs */

const vi_tea_purchase_paid_at_by = /** @type {(inputs: Tea_Purchase_Paid_At_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã thanh toán ${i?.time} bởi ${i?.name}`)
};

/**

* @param {Tea_Purchase_Paid_At_ByInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_paid_at_by = /** @type {((inputs: Tea_Purchase_Paid_At_ByInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Paid_At_ByInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_paid_at_by(inputs)
});